
export default {
    name: 'historique-info-complementaire',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


